const componentStyles = (theme) => ({
  collapseRoot: {
    paddingBottom: 0,
    "& $listItemRoot": {
      fontSize: ".8125rem",
      padding: ".5rem 1rem !important",
    },
  },
  listRoot: {
    marginTop: "0rem",
    height: "100%",
  },
  listRootCollapse: {
    padding: "0!important",
  },
  listItemRoot: {
    display: "flex",
    fontSize: ".9rem",
    color: "#000",
    padding: ".8125rem 1rem !important",
    borderRadius: ".375rem",
    marginRight: ".5rem",
    marginLeft: ".5rem",
    width: "auto",
    "&:hover": {
      color: theme.palette.tenant.main,
    },
  },
  // Expanded group header. Tinted lighter than the selected route below it so
  // the two read as group vs. current page rather than competing highlights.
  listItemRootCollapseActive: {
    background: theme.palette.tenant.main + "14!important",
    color: theme.palette.tenant.main + "!important",
    fontWeight: 600,
    "&:hover": {
      color: theme.palette.tenant.main + "!important",
    },
  },
  listItemRootCollapseIcon: {
    transition: "all .15s ease",
  },
  listItemRootCollapseActiveIcon: {
    transform: "rotate(90deg)",
  },
  listItemRootUpgradeToPro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: "10px",
    },
    "&,&:hover": {
      background: theme.palette.gray[100] + "!important",
    },
    "&:before": {
      display: "none",
    },
  },
  // Active route. Without a background the selected row was indistinguishable
  // from the rest, so tint it with the tenant primary and match the text to the
  // icon, which is already tenant-colored.
  listItemSelected: {
    color: theme.palette.tenant.main,
    fontWeight: 600,
    "&$listItemRoot,&$listItemRoot:hover": {
      backgroundColor: theme.palette.tenant.main + "1f",
      color: theme.palette.tenant.main,
    },
  },
  listItemIconRoot: {
    minWidth: "2.25rem",
    fontSize: ".9375rem",
    lineHeight: "1.5rem",
    display: "inline-block",
    top: "2px",
  },
  divider: {
    marginBottom: "1rem",
    marginTop: "1rem",
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
  },
  // Section heading. Quiet enough to read as a label rather than a link:
  // small, uppercase, muted, with the breathing room above doing the grouping.
  title: {
    marginTop: "1.25rem",
    paddingTop: ".25rem",
    paddingBottom: ".375rem",
    fontSize: ".6875rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: ".08em",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    color: theme.palette.gray[500],
  },
  // Closes the logo band, so the collapse toggle reads as a control sitting in
  // a header rather than floating beside the logo.
  logoDivider: {
    marginBottom: ".5rem",
  },
  // Muted and small: the collapse toggle is a rarely-used control and shouldn't
  // compete with the logo it sits next to.
  miniToggleRoot: {
    padding: ".5rem",
    color: theme.palette.gray[400],
    "&:hover": {
      color: theme.palette.tenant.main,
      backgroundColor: theme.palette.tenant.main + "14",
    },
  },
  // Clickable version of the above -- a heading that collapses its group.
  sectionHeaderRoot: {
    display: "flex",
    alignItems: "center",
    padding: ".25rem 1rem .25rem 1.5rem",
    marginTop: ".5rem",
    fontSize: ".6875rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: ".08em",
    color: theme.palette.gray[500],
    "&:hover": {
      color: theme.palette.tenant.main,
      backgroundColor: "transparent",
    },
  },
  logoClasses: {
    maxHeight: "2.8rem",
    maxWidth: "100%",
    verticalAlign: "middle",
    borderStyle: "none",
  },
  logoLinkClasses: {
    fontSize: "1.25rem",
    lineHeight: "inherit",
    whiteSpace: "nowrap",
    textDecoration: "none",
    display: "block",
    textAlign: "center",
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
  textPrimaryLight: {
    color: theme.palette.primary.light,
  },
  textError: {
    color: theme.palette.error.main,
  },
  textErrorLight: {
    color: theme.palette.error.light,
  },
  textWarning: {
    color: theme.palette.warning.main,
  },
  textWarningLight: {
    color: theme.palette.warning.light,
  },
  // Nearly every sidebar route declares iconColor: "Info", so this is where
  // the sidebar icons get their color. Tenant primary at full strength; falls
  // back to the stock info cyan when the tenant sets no primary.
  textInfo: {
    color: theme.palette.tenant.main,
  },
  textInfoLight: {
    color: theme.palette.info.light,
  },
  textSuccess: {
    color: theme.palette.success.main,
  },
  textSuccessLight: {
    color: theme.palette.success.light,
  },
  textDefault: {
    color: theme.palette.dark.main,
  },
  menuPaper: {
    width: "calc(100% - 2rem)",
  },
  outlineNone: {
    outline: "none!important",
  },
  drawerDockedMiniActive: {
    width: "62px",
    overflowX: "hidden",
  },
  drawerPaperMiniActive: {
    width: "62px",
    overflowX: "hidden",
  },
});

export default componentStyles;
